import { ButtonBase, IconButton, Stack, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { useGlobalContext } from "../../stores/Global";
import AvatarWithInitials from "../atoms/AvatarWithInitials";
import AccountPopover from "./AccountPopover";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function AccountIconButton() {
  const { context } = useGlobalContext();
  const anchorEl = useRef<any>(null);
  const [open, setOpen] = useState(false);

  return (
    <>
      <ButtonBase ref={anchorEl} onClick={() => setOpen(true)} sx={{ p: 1 }}>
        <Stack direction={"row"} spacing={2} alignItems={"center"}>
          <AvatarWithInitials size={36}>
            {context.user?.name || ""}
          </AvatarWithInitials>
          <Typography color="textPrimary">{context.user?.username}</Typography>
        </Stack>
        <ArrowDropDownIcon color="disabled" />
      </ButtonBase>
      <AccountPopover
        open={open}
        anchorEl={anchorEl.current}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      />
    </>
  );
}
